import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import { LoginButton, NoAccountWrapper, Register, Wrapper } from './LoginForm';
import { DsiCheckBox as CheckBox } from '../../..';
import { CheckBoxWrapper, StyledLabel } from '../Category/ProductFilter';

interface Props {
  handleIsVisible: any;
  handleEndUser: any;
  isEndUser: boolean;
  enableEndUser: boolean;
  enableWarehouse: boolean;
}

function PreRegisterForm(props) {
  const { handleEndUser, isEndUser, handleIsVisible, enableEndUser, enableWarehouse } = props;
  return (
    <Wrapper>
      <Header>{`${__('Registrácia')}`}</Header>
      {enableEndUser? 
          <StyledCheckBoxWrapper>
            <CheckBox
              name="withVat"
              selected={isEndUser}
              rounded={true}
              onClick={handleEndUser}
            />
            <StyledLabel
              htmlFor="withVat"
              selected={isEndUser}
              onClick={handleEndUser}
            >
              {__('Som koncový zákazník')}
            </StyledLabel>
          </StyledCheckBoxWrapper>
          :<></>
      }
      
      {enableWarehouse?
        <CheckBoxWrapper>
          <CheckBox
            name="withVat"
            selected={!isEndUser}
            rounded={true}
            onClick={handleEndUser}
          />
          <StyledLabel
            htmlFor="withVat"
            selected={!isEndUser}
            onClick={handleEndUser}
          >
            {__('Chcem sa stať veľkoobchodným partnerom')}
          </StyledLabel>
        </CheckBoxWrapper>
        :<></>
      }
      <LoginButton type="submit" onClick={handleIsVisible}>
        {`${__('Pokračovať')}`}
      </LoginButton>
      <NoAccountWrapper>
        {`${__('Máte u nás účet')}? `}
        <Link to={__r('routes:prihlasenie', '/prihlasenie')}>
          <Register>{__('Prihláste sa')}</Register>
        </Link>
      </NoAccountWrapper>
    </Wrapper>
  );
}

const Header = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const StyledCheckBoxWrapper = styled(CheckBoxWrapper)`
  margin-bottom: ${rem(24)};
`;

export { PreRegisterForm as DsiPreRegisterForm };
